/**
 * 版本管理
 */

export const versionShowList = [{
        prop: "appSystem",
        label: "系统",
        width: "150",
        format: "appSystem",
        order: false,
        isShow: true
    },
    {
        prop: "versionCode",
        label: "应用版本号",
        width: "150",
        format: "",
        order: false,
        isShow: true
    },
    {
        prop: "versionName",
        label: "版本信息",
        width: "150",
        format: "",
        order: false,
        isShow: true
    },
    {
        prop: "updateStatus",
        label: "强制升级",
        width: "150",
        format: "updateStatus",
        order: false,
        isShow: true
    },
    {
        prop: "status",
        label: "状态",
        width: "150",
        format: "status",
        order: false,
        isShow: true
    },
    {
        prop: "apkSize",
        label: "安装包大小/kb",
        width: "150",
        format: "",
        order: false,
        isShow: true
    },
    {
        prop: "downloadUrl",
        label: "安装包下载地址",
        width: "150",
        format: "downloadUrl",
        order: false,
        isShow: true
    },
    {
        prop: "modifyContent",
        label: "版本说明",
        width: "150",
        format: "",
        order: false,
        isShow: true
    },
    {
        prop: "creatorName",
        label: "创建人",
        width: "150",
        format: "type",
        order: false,
        isShow: true
    },
    {
        prop: "creationTime",
        label: "创建时间",
        width: "150",
        format: "datetime",
        order: false,
        isShow: true
    },
    {
        prop: "auditor",
        label: "审核人",
        width: "150",
        format: "type",
        order: false,
        isShow: true
    },
    {
        prop: "auditTime",
        label: "审核时间",
        width: "150",
        format: "datetime",
        order: false,
        isShow: true
    }
]